@if (activeFields$ | async; as activeFields) {
  <form [formGroup]="form">
    <div class="d-flex g-2 me-2">
      @if (activeFields.includes('min')) {
        <input
          class="form-control form-control-sm me-2"
          [ngClass]="
            activeFields.includes('begin') || activeFields.includes('end')
              ? 'col-6'
              : activeFields.includes('min') && activeFields.includes('max')
                ? 'col-6'
                : 'col-12'
          "
          formControlName="min"
          type="text" />
      }
      @if (activeFields.includes('max')) {
        <input
          class="form-control form-control-sm me-2"
          [ngClass]="
            activeFields.includes('begin') || activeFields.includes('end')
              ? 'col-6'
              : activeFields.includes('min') && activeFields.includes('max')
                ? 'col-6'
                : 'col-12'
          "
          formControlName="max"
          type="text" />
      }
    </div>
    @if (activeFields.includes('begin')) {
      <mypayter-portal-datetime-picker
        formControlName="begin"></mypayter-portal-datetime-picker>
    }
    @if (activeFields.includes('end') && activeFields.includes('begin')) {
      <span>to</span>
    }
    @if (activeFields.includes('end')) {
      <mypayter-portal-datetime-picker
        class="second-picker"
        formControlName="end"></mypayter-portal-datetime-picker>
    }
  </form>
}
